define('bindingHandlers/flipswitch',[
    'lib/knockout',
    'lib/lodash4',
    'jquery',
    'util/keyCode',
    'util/domUtils',

    'extensions/i18n/knockout.i18n'
], function (
    ko,
    _,
    $,
    keyCode,
    domUtils,
    i18n
) {
    'use strict';
    var EVENT_NAMESPACE = ".flipswitch-evt";
    var FLIPSWITCH_CLASS = "flipswitch";
    var FLIPSWITCH_ANIMATION_CLASS = "flipswitch-animate";

    var FLIPSWITCH_ON_CLASS = "flipswitch-on";
    var FLIPSWITCH_OFF_CLASS = "flipswitch-off";

    var FLIPSWITCH_DISABLED_CLASS = "flipswitch-disabled";

    var ON_MESSAGE_KEY = "flipswitch.on";
    var OFF_MESSAGE_KEY = "flipswitch.off";
    var TOGGLE_BTN_LABEL_KEY = "flipswitch.toggle";

    var setOn = function ($element) {
        $element.removeClass(FLIPSWITCH_OFF_CLASS);
        $element.addClass(FLIPSWITCH_ON_CLASS);
    };

    var setOff = function ($element) {
        $element.removeClass(FLIPSWITCH_ON_CLASS);
        $element.addClass(FLIPSWITCH_OFF_CLASS);
    };

    var createFlipswitchDOM = function ($element, options) {
        $element.addClass(FLIPSWITCH_CLASS);
        $element.attr('tabIndex', 0);

        var onMessageKey = options.onLabelKey || ON_MESSAGE_KEY;
        var offMessageKey = options.offLabelKey || OFF_MESSAGE_KEY;
        var toggleLabelKey = options.toggleLabelKey || TOGGLE_BTN_LABEL_KEY;

        //
        // Create the Flipswitch DOM
        //
        $("<span/>", {"class": "fs-state fs-state-inactive"})
            .append($("<span/>", {
                "class": "fs-label",
                "text": i18n.renderString(offMessageKey)
            }))
            .appendTo($element);

        $("<span/>", {"class": "fs-state fs-state-active"})
            .append($("<span/>", {
                "class": "fs-label",
                "text": i18n.renderString(onMessageKey)
            }))
            .appendTo($element);

        $("<button/>", {
            "class": "fs-btn",
            "type": "button",
            "tabIndex": "-1", // the whole switch will get focus, not the button inside it
            "aria-label": ko.i18n.renderString(toggleLabelKey)
        }).appendTo($element);

        //
        // Determine the width of the Flipswitch
        //
        var labelWidthSum = 0;

        $(".fs-label", $element).each(function () {
            var elemWidth = $(this).outerWidth();
            // Flipswitches that are Hidden may not have a width
            if (elemWidth === 0) {
                var size = domUtils.getHiddenElementOuterSize($(this));
                if (size) {
                    elemWidth = size.width;
                }
            }
            // Get the largest width of the 2 labels.
            if (elemWidth > labelWidthSum) {
                labelWidthSum = elemWidth;
            }
        });

        // Add in the size of the button element
        var buttonWidth = $(".fs-btn", $element).outerWidth() || 28; // If element is hidden, button width will be 0
        labelWidthSum += buttonWidth;

        // add 20px of padding here instead of CSS since the label and button elements
        // are position: absolute
        labelWidthSum += 20;

        $element.css("width", labelWidthSum + "px");
    };

    /**
     * A flipswitch widget to easily indicate when a value is "On" or "Off". This binding
     * will take an observable as an argument and changes its value between true and
     * false as a user interacts with the widget.
     *
     * # Required Arguments
     *
     * @param {Boolean or Object} value - An observable that will be updated with the boolean state
     *  of the flipswitch as the user interacts with it. This argument can be passed in
     *  as the only argument to the binding or as the "value" attribute to the argument
     *  object.
     *
     * # Options:
     *    @param {String} onLabelKey: localization key for the text to display for the ON state
     *    @param {String} offLabelKey: localization key for the text to display for the OFF state
     *    @param {Boolean|Function} disabled: true if this control is in a 'disabled' state. Default = not disabled
     *
     * # Example
     *
     * <div data-bind="flipswitch: myObservable"></div>
     */
    ko.bindingHandlers.flipswitch = {

        init: function (element, valueAccessor) {
            var $element = $(element);
            var bindingData = valueAccessor();
            var value = _.isPlainObject(bindingData) ? bindingData.value : bindingData;

            if (_.isUndefined(value)) {
                throw new Error("flipswitch binding requires a reference to an observable or an object with a 'value' attribute as its argument.");
            }

            var subscription = value.subscribe(function () {
                $element.addClass(FLIPSWITCH_ANIMATION_CLASS);
            });
            // Create the DOM for the flipswitch UI
            createFlipswitchDOM($element, bindingData);

            $element.on('keypress' + EVENT_NAMESPACE + ' click' + EVENT_NAMESPACE, function (e) {
                if ($element.hasClass(FLIPSWITCH_DISABLED_CLASS)) {
                    return;
                }
                if(e.type === 'keypress' && !(e.keyCode === keyCode.ENTER || e.keyCode === keyCode.SPACE)) {
                    return;
                }
                // prevent scrolling for space key
                if (e.type === 'keypress' && e.keyCode === keyCode.SPACE) {
                    e.preventDefault();
                }

                $element.focus();
                var isOn = ko.unwrap(value);
                if (isOn) {
                    value(false);
                } else {
                    value(true);
                }

                // Trigger the change event to ensure that other bindings see that the
                // element's value has changed.
                ko.utils.triggerEvent(element, "change");
            });
            // Clean up the binding handler when the element is removed from the DOM.
            ko.utils.domNodeDisposal.addDisposeCallback(element, function () {
                $element.off(EVENT_NAMESPACE);
                subscription.dispose();
            });
        }, // end init()
        update: function (element, valueAccessor) {
            var bindingData = valueAccessor();
            var value = _.isPlainObject(bindingData) ? ko.unwrap(bindingData.value) : ko.unwrap(bindingData);
            var $element = $(element);
            var isDisabled = ko.unwrap(bindingData.disabled);

            // Update the class' value based on the 'value' binding
            if (value) {
                setOn($element);
            } else {
                setOff($element);
            }

            // Manage the 'disabled' binding
            if (isDisabled) {
                $element.addClass(FLIPSWITCH_DISABLED_CLASS);
                $element.attr('disabled', true);
                $element.removeAttr('tabIndex');
                $element.find('button').attr('disabled', true);
                $element.find('button').removeAttr('tabIndex');
            } else {
                $element.removeClass(FLIPSWITCH_DISABLED_CLASS);
                $element.removeAttr('disabled');
                $element.attr('tabIndex', 0);
                $element.find('button').removeAttr('disabled');
                $element.find('button').attr('tabIndex', -1);
            }

            // give some time for animation to complete prior to removing animation class
            _.delay(function() {
                $element.removeClass(FLIPSWITCH_ANIMATION_CLASS);
            }, 100);

        } // end update()
    }; // end flipswtich()
});

